import script from "./Qixiang.vue?vue&type=script&setup=true&lang=js"
export * from "./Qixiang.vue?vue&type=script&setup=true&lang=js"

import "./Qixiang.vue?vue&type=style&index=0&id=0be564b0&lang=less&scoped=true"
script.__scopeId = "data-v-0be564b0"

export default script